import { Temporal } from "temporal-polyfill";

export function followUpInput(instant: string, timezone: string): string {
  return Temporal.Instant.from(instant)
    .toZonedDateTimeISO(timezone)
    .toPlainDateTime()
    .toString({ smallestUnit: "minute" });
}
export function followUpInstant(value: string, timezone: string): string {
  if (!value) throw new Error("Choose a follow-up date and time.");
  try {
    return Temporal.PlainDateTime.from(value)
      .toZonedDateTime(timezone, { disambiguation: "reject" })
      .toInstant()
      .toString();
  } catch {
    throw new Error(
      "This local time is unavailable or repeats during a clock change. Choose another time.",
    );
  }
}
